var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var SchemaMenuItem = /** @class */ (function (_super) {
    __extends(SchemaMenuItem, _super);
    function SchemaMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new schema menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SchemaMenuItem.prototype.create = function (body) {
        return this.rawCreate(Utils.serializeRequestBody(body, {
            type: 'schema_menu_item',
            attributes: ['label', 'position', 'kind'],
            relationships: ['item_type', 'parent'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Create a new schema menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SchemaMenuItem.prototype.rawCreate = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/schema-menu-items',
            body: body,
        });
    };
    /**
     * Update a schema menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SchemaMenuItem.prototype.update = function (schemaMenuItemId, body) {
        return this.rawUpdate(Utils.toId(schemaMenuItemId), Utils.serializeRequestBody(body, {
            id: Utils.toId(schemaMenuItemId),
            type: 'schema_menu_item',
            attributes: ['label', 'position', 'kind'],
            relationships: ['item_type', 'parent', 'children'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Update a schema menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SchemaMenuItem.prototype.rawUpdate = function (schemaMenuItemId, body) {
        return this.client.request({
            method: 'PUT',
            url: "/schema-menu-items/".concat(schemaMenuItemId),
            body: body,
        });
    };
    /**
     * List all schema menu items
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SchemaMenuItem.prototype.list = function (queryParams) {
        return this.rawList(queryParams).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List all schema menu items
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SchemaMenuItem.prototype.rawList = function (queryParams) {
        return this.client.request({
            method: 'GET',
            url: '/schema-menu-items',
            queryParams: queryParams,
        });
    };
    /**
     * Retrieve a schema menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SchemaMenuItem.prototype.find = function (schemaMenuItemId) {
        return this.rawFind(Utils.toId(schemaMenuItemId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a schema menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SchemaMenuItem.prototype.rawFind = function (schemaMenuItemId) {
        return this.client.request({
            method: 'GET',
            url: "/schema-menu-items/".concat(schemaMenuItemId),
        });
    };
    /**
     * Delete a schema menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SchemaMenuItem.prototype.destroy = function (schemaMenuItemId) {
        return this.rawDestroy(Utils.toId(schemaMenuItemId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Delete a schema menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SchemaMenuItem.prototype.rawDestroy = function (schemaMenuItemId) {
        return this.client.request({
            method: 'DELETE',
            url: "/schema-menu-items/".concat(schemaMenuItemId),
        });
    };
    /**
     * Reorders a set of schema menu items
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/reorder
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     *
     * @deprecated This API call is to be considered private and might change without notice
     */
    SchemaMenuItem.prototype.reorder = function (body) {
        return this.rawReorder(Utils.serializeRequestBody(body, {
            type: 'schema_menu_item',
            attributes: ['position'],
            relationships: ['parent'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Reorders a set of schema menu items
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/schema-menu_item/reorder
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     *
     * @deprecated This API call is to be considered private and might change without notice
     */
    SchemaMenuItem.prototype.rawReorder = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/schema-menu-items/reorder',
            body: body,
        });
    };
    SchemaMenuItem.TYPE = 'schema_menu_item';
    return SchemaMenuItem;
}(BaseResource));
export default SchemaMenuItem;
//# sourceMappingURL=SchemaMenuItem.js.map